import { httpRequest } from '@app/httpRequest.js';
import type { Processor } from '@app/store/middleware/processorMiddleware.js';
import { objectToURLSearchParams } from '@shared/stringUtils.js';
import z from 'zod';
import { createFilter } from '../../galleryUtils.js';
import { loadGalleryMessages } from '../../translations/loadGalleryMessages.js';
import {
  galleryList,
  galleryRequestImage,
  gallerySetImageIds,
} from '../actions.js';

export const galleryRequestImagesByOrderProcessor: Processor<
  typeof galleryList
> = {
  actionCreator: galleryList,
  async handle({ getState, dispatch, action, toastError }) {
    const res = await httpRequest({
      getState,
      url:
        '/gallery/pictures?' +
        objectToURLSearchParams({
          by: 'order',
          orderBy: action.payload.substring(1),
          direction: action.payload[0] === '+' ? 'asc' : 'desc',
          ...createFilter(getState().gallery.filter),
        }),
      expectedStatus: 200,
    }).catch(async (err) => {
      await toastError(
        err,
        loadGalleryMessages,
        'picturesFetchingError',
        'gallery.picturesFetchingError',
      );

      return null;
    });

    if (!res) {
      return;
    }

    const ids = z
      .array(z.object({ id: z.number() }))
      .parse(await res.json())
      .map((item) => item.id);

    dispatch(gallerySetImageIds(ids));

    if (ids[0] !== undefined) {
      dispatch(galleryRequestImage(ids[0]));
    }
  },
};
